// extracted by mini-css-extract-plugin
export default {"container":"AddCapteurComposante_container__8+Ypd","btn_stylo":"AddCapteurComposante_btn_stylo__6Ecml"};